/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { ExtensionFilteringModule } from '../../extension-filtering/extension-filtering.module';
import { IpWhiteListModule } from '../../ip-white-list/ip-white-list.module';
import { DeleteCifsShareModule } from '../delete-cifs-share/delete-cifs-share.module';
import { HomedirRuleCifsShareModule } from '../homedir-rule-cifs-share/homedir-rule-cifs-share.module';
import { ModifyCifsShareModule } from '../modify-cifs-share/modify-cifs-share.module';
import { ClientCifsShareModule } from './../client-cifs-share/client-cifs-share.module';
import { DetailCifsShareComponent } from './detail-cifs-share.component';
@NgModule({
    declarations: [DetailCifsShareComponent],
    exports: [DetailCifsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        DeleteCifsShareModule,
        ModifyCifsShareModule,
        ClientCifsShareModule,
        HomedirRuleCifsShareModule,
        ExtensionFilteringModule,
        IpWhiteListModule,
    ],
})
export class DetailCifsShareModule { }
